export default "__VITE_ASSET__BfidXOW5__"